/* eslint-disable */
import wx from "weixin-js-sdk";
import axios from "axios";

const wxShare = function(option) {
    // let wxLink = window.location.href.split("#")[0];
    let wxData = new FormData();
    wxData.append("url", "https://h5.eventnet.cn/72Hours/");
    axios
        .post("https://h5.eventnet.cn/wxAjax/fx/index.php", wxData)
        .then(el => {
            let d = el.data;
            wx.config({
                appId: d.appId,
                timestamp: d.timestamp,
                nonceStr: d.nonceStr,
                signature: d.signature,
                jsApiList: [
                    "checkJsApi",
                    "onMenuShareTimeline",
                    "onMenuShareAppMessage",
                    "scanQRCode"
                ]
            });
            wx.ready(function() {
                iniShare({
                    title: option.title,
                    desc: option.desc,
                    link: option.link,
                    logo: option.logo
                });
            });
            wx.error(function(res) {
                console.log(res.errMsg);
            });
        })
        .catch(function(error) {
            console.log(error);
        });
};
function iniShare(data) {
    var shareData = {
        title: data.title,
        desc: data.desc,
        link: data.link,
        imgUrl: data.logo,
        trigger: function(res) {},
        success: function(res) {},
        cancel: function(res) {},
        fail: function(res) {}
    };
    /* 好友 */
    wx.onMenuShareAppMessage(shareData);
    /* 朋友圈 */
    shareData = {
        title: data.title,
        link: data.link,
        imgUrl: data.logo,
        trigger: function(res) {},
        success: function(res) {},
        cancel: function(res) {},
        fail: function(res) {}
    };
    wx.onMenuShareTimeline(shareData);
}

export { wxShare };



// WEBPACK FOOTER //
// ./src/wxShare.js